export const LABEL_TYPE_OBJ = Object.freeze({
  dictionary: '字典属性名称',
  txt: '文本属性名称',
  number: '数量属性名称',
  money: '金额属性名称',
  location: 'GEO属性名称'
})

export function ATTR_LIST() {
  return [
    {
      label: '字典属性名称',
      attr_name: '来源',
      attr_identity: 'source',
      attr_type: 'dictionary',
      disabled: true
    },
    {
      label: '文本属性名称',
      attr_name: '来源内容',
      attr_identity: 'source_content',
      attr_type: 'txt',
      disabled: true
    },
    {
      label: '文本属性名称',
      attr_name: '活动营销编码',
      attr_identity: 'serial_number',
      attr_type: 'txt',
      disabled: true
    },
    {
      label: 'GEO属性名称',
      attr_name: '地理位置',
      attr_identity: 'address',
      attr_type: 'location',
      disabled: true
    }
  ]
}
// 字典、文本:等于、不等于、包含、不包含、为空、不为空
export const RELATION_ONE = [
  {
    value: 'equal',
    label: '等于'
  },
  {
    value: 'not_equal',
    label: '不等于'
  },
  {
    value: 'contain',
    label: '包含'
  },
  {
    value: 'not_contain',
    label: '不包含'
  },
  {
    value: 'empty',
    label: '为空'
  },
  {
    value: 'not_empty',
    label: '不为空'
  }
]
//数字、金额：等于、不等于、大于、小于、区间
export const RELATION_TWO = [
  {
    value: 'equal',
    label: '等于'
  },
  {
    value: 'not_equal',
    label: '不等于'
  },
  {
    value: 'gt',
    label: '大于'
  },
  {
    value: 'lt',
    label: '小于'
  },
  {
    value: 'gtele',
    label: '区间'
  }
]
// 地址: 等于、不等于、为空、不为空
export const RELATION_THREE = [
  {
    value: 'equal',
    label: '等于'
  },
  {
    value: 'not_equal',
    label: '不等于'
  },
  {
    value: 'empty',
    label: '为空'
  },
  {
    value: 'not_empty',
    label: '不为空'
  }
]
export const RELATIONSHIP_OBJ = {
  txt: RELATION_ONE,
  dictionary: RELATION_ONE,
  number: RELATION_TWO,
  money: RELATION_TWO,
  location: RELATION_THREE
}
